export default __webpack_public_path__ + "static/media/sound-on.9a6adc34.svg";